import yup from '../../../../helpers/yupInstance';
import type { TFunction } from 'i18next';

export function getAddSubscriptionPlanFormValidation(t: TFunction) {
  return yup.object({
    scope: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.scopeRequired')),
    period: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.periodRequired')),
    stripePlanId: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.stripePlanIdRequired')),
    orderNumber: yup
      .number()
      .required(t('formikValidation.orderNumberRequired')),
  });
}
